"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateUser = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _reduxBatchedActions = require("redux-batched-actions");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _skybaseComponents = require("skybase-ui/skybase-components");

var _sbModal = require("skybase-ui/skybase-components/sb-modal");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _components = require("../../common/components");

var _actions2 = require("../actions");

var _utils = require("../utils");

var _constants = require("../constants");

var _constants2 = require("../../roles/constants");

var _constants3 = require("../../constants");

var _utils2 = require("../../utils");

var _validationRules = require("../validation-rules");

var _usersI18n = require("../users-i18n");

var _messagesI18n = require("../../messages-i18n");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _CreateUser = /*#__PURE__*/function (_FormComponent) {
  (0, _inherits2.default)(_CreateUser, _FormComponent);

  var _super = _createSuper(_CreateUser);

  function _CreateUser(props) {
    var _this;

    (0, _classCallCheck2.default)(this, _CreateUser);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHeader", function () {
      var _this$props = _this.props,
          _ = _this$props.intl.formatMessage,
          handleOverlayClick = _this$props.handleOverlayClick;
      return /*#__PURE__*/_react.default.createElement(_sbModal.SbModalHeader, {
        title: _(_usersI18n.messages.addNewUser),
        onCloseBtnClick: handleOverlayClick
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderFooter", function () {
      var loading = _this.props.loading;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-footer fl-container fl-justify-end"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-left"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-center"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-right"
      }, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLoaderButton, {
        loading: loading,
        className: "primary",
        onClick: _this.handleOnConfirmClick
      }, _this.confirmButtonTitle)));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInputs", function () {
      var _this$props2 = _this.props,
          _ = _this$props2.intl.formatMessage,
          roles = _this$props2.roles;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, _this.renderInputWithLabel('email', _(_usersI18n.messages.email), {
        placeholder: 'you@example.com'
      }), _this.renderInputWithLabel('name', _(_usersI18n.messages.name), {
        placeholder: _(_usersI18n.messages.enterYourName)
      }), _this.renderInputWithLabel('phoneNumber', _(_usersI18n.messages.phone), {
        placeholder: _(_usersI18n.messages.enterYourPhoneNumber)
      }), _this.renderButtonBarWithLabel('lockoutEnd', _(_messagesI18n.messages.enabled), [{
        title: _(_messagesI18n.messages.enabled),
        value: true
      }, {
        title: _(_messagesI18n.messages.disabled),
        value: false
      }], {}, _utils.convertLockoutEndToBooleans), _this.renderInputWithLabel('roles', _(_usersI18n.messages.roles), {
        componentType: 'select',
        items: roles.map(function (role) {
          return {
            value: role,
            label: role
          };
        }),
        multiSelect: true,
        liveSearch: true,
        title: _(_usersI18n.messages.selectRoles)
      }), _this.renderInputWithLabel('password', _(_usersI18n.messages.password), {
        componentType: 'password',
        placeholder: _(_usersI18n.messages.createAPassword)
      }), _this.renderInputWithLabel('confirmPassword', _(_usersI18n.messages.confirmPassword), {
        componentType: 'password',
        placeholder: _(_usersI18n.messages.retypeYourPassword)
      }));
    });
    var _2 = props.intl.formatMessage;
    _this.validationRules = (0, _validationRules.getValidationRules)('create', _2);
    _this.confirmButtonTitle = _2(_messagesI18n.messages.confirm);
    _this.isModal = true;
    _this.beforeConfirm = [{
      name: 'lockoutEnd',
      normalize: _utils.convertEnabledBooleanToValues
    }];
    return _this;
  }

  (0, _createClass2.default)(_CreateUser, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_sbModal.SbModal, {
        Header: this.renderHeader(),
        Footer: this.renderFooter(),
        width: 310,
        height: "auto",
        className: "oauth-modal"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-message-modal-content"
      }, this.renderInputs()));
    }
  }]);
  return _CreateUser;
}(_components.FormComponent);

(0, _defineProperty2.default)(_CreateUser, "propTypes", _objectSpread(_objectSpread({}, _CreateUser.propTypes), {}, {
  data: _propTypes.default.shape({
    id: _propTypes.default.string,
    email: _propTypes.default.string,
    name: _propTypes.default.string,
    password: _propTypes.default.string,
    confirmPassword: _propTypes.default.string,
    lockoutEnd: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
  }).isRequired,
  roles: _propTypes.default.arrayOf(_propTypes.default.string),
  handleOverlayClick: _propTypes.default.func.isRequired
}));

var mapStateToProps = function mapStateToProps(state) {
  var _getOAuthState$USERS_ = (0, _utils2.getOAuthState)(state)[_constants.USERS_STATE_KEY_NAME],
      _getOAuthState$USERS_2 = _getOAuthState$USERS_[_constants.USER_STATE_KEYS.CREATE_USER],
      data = _getOAuthState$USERS_2.data,
      userState = _getOAuthState$USERS_2.state,
      _getOAuthState$USERS_3 = _getOAuthState$USERS_.listConfig,
      pageSize = _getOAuthState$USERS_3.pageSize,
      pageNumber = _getOAuthState$USERS_3.pageNumber;

  var roles = (0, _utils2.getOAuthState)(state)[_constants2.ROLES_STATE_KEY_NAME].all;

  return {
    data: data,
    loading: userState === _constants3.STATES.LOADING,
    pageSize: pageSize,
    pageNumber: pageNumber,
    roles: roles
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var formatMessage = ownProps.intl.formatMessage;
  return {
    handleOnChangeParams: function handleOnChangeParams(attribute, value) {
      return dispatch((0, _actions2.changeCreateUserParams)(attribute, value));
    },
    handleOnConfirm: function handleOnConfirm(user, listConfig) {
      return dispatch((0, _utils.createUser)(user, listConfig, formatMessage));
    },
    handleOverlayClick: function handleOverlayClick() {
      return dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions.closeModal)(), (0, _actions2.clearCreateUserParams)()]));
    }
  };
};

var CreateUser = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_CreateUser));
exports.CreateUser = CreateUser;
//# sourceMappingURL=create-user.js.map